
import {
  computed, defineComponent, PropType,
} from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'primevue/button';
import AutoRechargeBlock from '@/components/billing/panels/AutoRechargeBlock.vue';
import { WalletSection } from '@/types/billing-types';

export default defineComponent({
  name: 'WalletPanel',

  components: { Button, AutoRechargeBlock },

  props: {
    wallet: {
      type: Object as PropType<WalletSection>,
      required: true,
    },
  },

  emits: ['buy-credits'],

  setup(props) {
    const { t } = useI18n();

    const currencySymbol = computed(() => (
      props.wallet.balance.currency === 'USD' ? '$' : '€'
    ));

    const formatQuantity = (n: number) => (
      new Intl.NumberFormat('fr-FR').format(n)
    );

    const formatPrice = (n: number) => {
      const trimmed = n.toFixed(4).replace(/0+$/, '').replace(/\.$/, '');
      return `${trimmed} ${currencySymbol.value}`;
    };

    const unitLabel = (action: 'sms' | 'whatsapp') => (
      action === 'whatsapp' ? t('billing.subscriptionPage.wallet.unit.whatsapp') : 'SMS'
    );

    // Date de renouvellement du cycle d'abonnement, affichée uniquement quand
    // le shop a effectivement des SMS inclus (sinon la date n'a pas de sens
    // ici). Source : `currentPlanLimit` exposé via `breakdown.included.resetAt`.
    // Format : "5 juin 2026" via Intl.DateTimeFormat, fallback brut.
    const includedResetLabel = computed(() => {
      const breakdown = props.wallet.balance.breakdown.included;
      if (!breakdown?.resetAt || breakdown.amount <= 0) return '';
      const date = new Date(breakdown.resetAt);
      if (Number.isNaN(date.getTime())) return breakdown.resetAt;
      return new Intl.DateTimeFormat('fr-FR', {
        day: 'numeric',
        month: 'long',
        year: 'numeric',
      }).format(date);
    });

    return {
      t,
      formatQuantity,
      formatPrice,
      unitLabel,
      includedResetLabel,
    };
  },
});
